export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden pt-20">
      {/* Background layers */}
      <div className="absolute inset-0 bg-[#0B0F19]" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#7C3AED]/20 via-transparent to-[#0B0F19]" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] bg-[#7C3AED]/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[400px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" />

      {/* Grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 w-full py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left: Copy */}
          <div className="flex-1 text-center lg:text-left">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm font-semibold px-4 py-2 rounded-full mb-6 animate-pulse">
              <span>🔥</span>
              <span>Sistema exclusivo para Negocios Peruanos</span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-[1.1] mb-6">
              Deja de Comprar PDFs de{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-300">
                &apos;10 Luquitas&apos;
              </span>{" "}
              y Empieza a Usar el{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#a78bfa] to-[#7C3AED]">
                Centro de Mando Digital
              </span>{" "}
              que Multiplica tus Ventas
            </h1>

            {/* Subtitle */}
            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              Obtén acceso inmediato a{" "}
              <strong className="text-white">NegoIA Perú</strong>: El único
              ecosistema que combina{" "}
              <strong className="text-[#a78bfa]">
                Inteligencia Artificial en tiempo real
              </strong>
              , scripts anti-vistos y estrategias de tráfico para escalar tu
              negocio local sin vender humo.
            </p>

            {/* CTA Button */}
            <div className="flex flex-col items-center lg:items-start gap-2">
              <a
                href="#cta"
                id="cta"
                className="inline-flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 bg-gradient-to-r from-orange-500 to-orange-400 hover:from-orange-400 hover:to-yellow-400 text-white font-black text-sm md:text-lg px-6 md:px-10 py-4 md:py-5 rounded-2xl sm:rounded-full transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-orange-500/40 cursor-pointer group w-full sm:w-auto max-w-xs sm:max-w-none text-center"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-rocket-line text-lg group-hover:rotate-12 transition-transform duration-300"></i>
                  QUIERO ACCEDER
                </span>
                <span>AL SISTEMA AHORA</span>
              </a>
              <p className="text-white/40 text-xs">
                Acceso inmediato. Pago 100% seguro. Solo S/ 15.
              </p>
              {/* Device compatibility */}
              <div className="flex flex-wrap items-center gap-2 mt-1 justify-center lg:justify-start">
                {[
                  { icon: "ri-smartphone-line", label: "iOS/Android" },
                  { icon: "ri-tablet-line", label: "Tablet" },
                  { icon: "ri-computer-line", label: "PC/Mac" },
                  { icon: "ri-lock-fill", label: "Acceso Privado" },
                ].map((d, i) => (
                  <div key={i} className="flex items-center gap-1 text-white/35">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className={`${d.icon} text-[#a78bfa] text-xs`}></i>
                    </div>
                    <span className="text-xs">{d.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Social proof mini */}
            <div className="flex items-center gap-4 mt-8 justify-center lg:justify-start">
              <div className="flex -space-x-2">
                {[
                  "https://readdy.ai/api/search-image?query=peruvian%20young%20entrepreneur%20smiling%20professional%20headshot%20portrait%20closeup%20warm%20lighting&width=40&height=40&seq=1&orientation=squarish",
                  "https://readdy.ai/api/search-image?query=latin%20american%20business%20woman%20smiling%20professional%20headshot%20portrait%20closeup%20warm%20lighting&width=40&height=40&seq=2&orientation=squarish",
                  "https://readdy.ai/api/search-image?query=young%20peruvian%20man%20entrepreneur%20smiling%20professional%20headshot%20portrait%20closeup&width=40&height=40&seq=3&orientation=squarish",
                ].map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt="usuario"
                    className="w-8 h-8 rounded-full border-2 border-[#0B0F19] object-cover object-top"
                  />
                ))}
              </div>
              <div>
                <div className="flex items-center gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-orange-400 text-xs"></i>
                  ))}
                </div>
                <p className="text-white/50 text-xs">+500 negocios peruanos ya dentro</p>
              </div>
            </div>
          </div>

          {/* Right: Dashboard Mockup */}
          <div className="flex-1 flex justify-center lg:justify-end relative">
            <div className="relative w-full max-w-lg">
              {/* Glow behind mockup */}
              <div className="absolute inset-0 bg-[#7C3AED]/30 rounded-3xl blur-3xl scale-110" />

              {/* Laptop frame */}
              <div className="relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-2xl p-3 shadow-2xl">
                {/* Screen top bar */}
                <div className="flex items-center gap-1.5 mb-2 px-1">
                  <div className="w-2.5 h-2.5 rounded-full bg-red-400/80"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-yellow-400/80"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-green-400/80"></div>
                  <div className="flex-1 bg-white/10 rounded-full h-4 mx-2 flex items-center px-2">
                    <span className="text-white/30 text-[9px]">app.negoia.pe/dashboard</span>
                  </div>
                </div>

                {/* Dashboard image */}
                <div className="rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20dark%20SaaS%20dashboard%20interface%20with%20AI%20analytics%20charts%20graphs%20purple%20neon%20glow%20data%20visualization%20premium%20software%20UI%20dark%20theme%20with%20sidebar%20navigation%20and%20metrics%20cards&width=600&height=380&seq=10&orientation=landscape"
                    alt="NegoIA Dashboard"
                    className="w-full h-auto object-cover object-top rounded-xl"
                  />
                </div>

                {/* Floating badge on mockup */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-orange-500 to-orange-400 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg shadow-orange-500/40 whitespace-nowrap">
                  🤖 IA Activa
                </div>
                <div className="absolute -bottom-4 -left-4 bg-gradient-to-r from-[#7C3AED] to-[#6d28d9] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg shadow-purple-500/40 whitespace-nowrap">
                  ✅ +500 usuarios activos
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0B0F19] to-transparent" />
    </section>
  );
}
